import repository from '@/services/repository';

const resource = '/Tasks';

export default {
    lookup(command: ITaskLookupQuery) {
        const formData = new FormData();

        for ( const key in command.options ) {
            if (command.options.hasOwnProperty(key)) {
                formData.append(key, JSON.stringify(command.options[key]));
            }
        }

        if (!command.projectId) {
            command.projectId = '';
        }

        let parentIdFilter = '';

        if (command.parentId) {
            parentIdFilter = `&parentId=${command.parentId}`;
        }

        return repository
            .post(`${resource}/lookup?projectId=${command.projectId}`
                + `&onlyMyTasks=${command.onlyMyTasks}&includeClosed=${command.includeClosed}${parentIdFilter}`,
                formData,
                {
                    headers: {'Content-Type': 'multipart/form-data' },
                });
    },
    getSingle(id: string) {
        return repository.get(`${resource}/${id}`);
    },
    create(payload: ITaskCreateCommand) {
        return repository.post<ITask>(`${resource}`, payload);
    },
    update(payload: ITaskUpdateCommand) {
        return repository.put(`${resource}/${payload.id}`, payload);
    },
    delete(id: string) {
        return repository.delete(`${resource}/${id}`);
    },
    createNote(payload: ITaskCreateNoteCommand) {
        return repository.post<ITaskNote>(`${resource}/AddNote`, payload);
    },
    /*
    get(userId: string, unassigned: boolean = false, projectId: string | null = null, includeClosed: boolean = false) {
        let qry = `?userId=${userId}&unassigned=${unassigned}&includeClosed=${includeClosed}`;
        if (projectId) {
            qry += `&projectId=${projectId}`;
        }
        return repository.get<ITaskListItem[]>(`${resource}` + qry);
    },
    getCountOfMyTasks() {
        return repository.get<number>(`${resource}/count`);
    },
    getSingle(id: string) {
        return repository.get(`${resource}/${id}`);
    },
    delete(id: string) {
        return repository.delete(`${resource}/${id}`);
    },*/
};
